/* TPW homepage Top Sellers tabs: switch the product grid in place. Panels are server-rendered in <template>s
   (sections/tpw-products.liquid) and cloned in on first hover/focus/tap. Plain links without JS. */
(function(){
  function init(root){
    if(!root||root.__tpwTT)return;root.__tpwTT=1;
    var list=root.querySelector('[data-tpw-toptabs]'),box=root.querySelector('[data-tpw-panels]');if(!list||!box)return;
    var tabs=[].slice.call(list.querySelectorAll('[role="tab"]')),va=root.querySelector('[data-tpw-viewall]');
    function byId(t){return document.getElementById(t.getAttribute('aria-controls'));}
    function panel(i){
      var t=tabs[i],p=byId(t);if(p)return p;
      var tpl=box.querySelector('template[data-tpw-panel="'+t.getAttribute('data-tab')+'"]');if(!tpl)return null;
      box.appendChild(document.importNode(tpl.content,true));p=byId(t);
      if(p){p.hidden=true;if(window.TPWSaved&&TPWSaved.refresh)TPWSaved.refresh();}
      return p;
    }
    /* start the first row of images early so the swap feels instant */
    function warm(i){var p=panel(i);if(!p||p.__w)return;p.__w=1;
      [].slice.call(p.querySelectorAll('img')).slice(0,4).forEach(function(im){im.loading='eager';});}
    /* hold the grid at its tallest height seen so far: switching tabs never pulls the content below upward */
    var maxH=0;window.addEventListener('resize',function(){maxH=0;box.style.minHeight='';},{passive:true});
    function select(i,focus){
      maxH=Math.max(maxH,box.offsetHeight);
      tabs.forEach(function(t,j){var on=j===i,p=on?panel(j):byId(t);
        t.classList.toggle('on',on);t.setAttribute('aria-selected',on?'true':'false');t.tabIndex=on?0:-1;
        if(p)p.hidden=!on;});
      maxH=Math.max(maxH,box.offsetHeight);box.style.minHeight=maxH+'px';
      var t=tabs[i];if(focus)t.focus({preventScroll:true});
      /* keep the active tab visible in the horizontally scrolling mobile tab row */
      if(list.scrollWidth>list.clientWidth){var lr=list.getBoundingClientRect(),tr=t.getBoundingClientRect();
        if(tr.left<lr.left||tr.right>lr.right-48)list.scrollBy({left:tr.left-lr.left-16,behavior:'smooth'});}
      if(va){va.href=t.getAttribute('data-url');va.textContent='View all '+t.getAttribute('data-label');}
    }
    tabs.forEach(function(t,i){
      t.addEventListener('click',function(e){
        if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.button>0)return; /* allow open-in-new-tab */
        e.preventDefault();if(t.getAttribute('aria-selected')!=='true')select(i,false);});
      ['pointerenter','focus','touchstart'].forEach(function(ev){t.addEventListener(ev,function(){warm(i);},{passive:true});});
    });
    list.addEventListener('keydown',function(e){
      var i=tabs.indexOf(document.activeElement);if(i<0)return;var n=null;
      if(e.key==='ArrowRight')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft')n=(i-1+tabs.length)%tabs.length;
      else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;
      else if(e.key===' '||e.key==='Spacebar'){e.preventDefault();select(i,false);return;}
      if(n!==null){e.preventDefault();select(n,true);}
    });
    root.__tpwSelect=function(el){var i=tabs.indexOf(el);if(i>-1)select(i,false);};
  }
  function all(){document.querySelectorAll('[data-tpw-toptabs-root]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',function(e){init(e.target.querySelector('[data-tpw-toptabs-root]'));});
  document.addEventListener('shopify:block:select',function(e){var r=e.target.closest&&e.target.closest('[data-tpw-toptabs-root]');if(r&&r.__tpwSelect)r.__tpwSelect(e.target);});
})();
